module.exports = __webpack_public_path__ + "img/Emory_Cohen.820a91ee.jpg";